import { render, staticRenderFns } from "./SegmentedRadio.vue?vue&type=template&id=cb65a40a"
import script from "./SegmentedRadio.vue?vue&type=script&lang=js"
export * from "./SegmentedRadio.vue?vue&type=script&lang=js"
import style0 from "./SegmentedRadio.vue?vue&type=style&index=0&id=cb65a40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports